import React from "react";
import { Button, Container, Title } from "./Boost.styles";

function Boost() {
  return (
    <Container>
      <Title>Boost your links today</Title>
      <Button>Get Started</Button>
    </Container>
  );
}

export default Boost;
